export var CountryCode;
(function (CountryCode) {
    CountryCode["US"] = "us";
    CountryCode["CA"] = "ca";
})(CountryCode || (CountryCode = {}));
//# sourceMappingURL=Types.js.map